module.exports = __webpack_public_path__ + "img/pastTitle.b15365fc.png";